var rtcShare = require('rtc-screenshare');
var quickconnect = require('quickconnect');

var peerKey = 'bbl-ss[peer-id]';
var peerId = sessionStorage.getItem(peerKey) || null;

angular.module('bbl.services.simpleshare', [])

.factory('connect', ['RTC_SIGNAL_HOST', 'ICE_SERVERS', 'ENV', function(signalHost, iceServers, env) {
  var connections = {};

  return function(room, user) {
    var userKey = room+(user.$id || user.username || user.name || user);

    if(!connections[userKey]) {
      connections[userKey] = quickconnect(signalHost, {
        room: room+'',
        iceTransports: 'relay',
        iceServers: iceServers,
        // manualJoin: true,
        debug: !env.isProd,
        id: peerId,
      }).reactive();

      sessionStorage.setItem(peerKey, connections[userKey].id);

      var createDataChannel = connections[userKey].createDataChannel;
      var channels = {};
      connections[userKey].createDataChannel = function(name) {
        if (!channels[name]) {
          channels[name] = createDataChannel(name);
        }

        return connections[userKey];
      };

      connections[userKey].createDataChannel(room+'-data');
    }

    var conn = connections[userKey];

    if(user) {
      conn.profile({user: user});
      window.cnnst = conn;
    }

    return conn;
  };
}])

.factory('watchCon', [function() {
  return function $watch(conn, callback) {
    if(!callback || typeof callback !== 'function') {
      return;
    }

    conn.on('peer:connect', onUpdate.bind(0, 'peerConnect'));
    conn.on('call:started', onUpdate.bind(0, 'callStarted'));
    conn.on('call:ended', onUpdate.bind(0, 'callEnded'));
    conn.on('stream:added', onUpdate.bind(0, 'sharing'));
    conn.on('stream:removed', onUpdate.bind(0, 'sharing'));
    conn.on('localstream:added', onUpdate.bind(0, 'sharing'));
    conn.on('localstream:removed', onUpdate.bind(0, 'sharing'));

    function getActiveStream(call) {
      return call.streams.filter(function(s) {
        if(s.active) {
          return true;
        }

        // firefox appears to not have MediaStream.active, so, find a way
        return s.getTracks().filter(function(t) {
          return t.readyState !== 'ended';
        }).length > 0;
      })[0];
    }

    function onUpdate(ev, peer) {
      var callers = conn.calls.keys().filter(function(id) {
          return true;
        // return conn.calls.get(id).active;
      }).map(function(id) {
        var call = conn.calls.get(id),
          peer = conn.peers.get(id);

        return {
          call: call, peer: peer,
          userData: peer.data.user || {},
          getStream: getActiveStream.bind(0, call),
        };
      });

      callback(ev, callers, peer);
    }
  };
}])

.factory('sharer', ['$q', 'connect', 'modals', function($q, connect, modals) {
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  var chrExt = isChrome ? rtcShare({
    chromeExtension: 'bbl screenshare', version: '^1.0.0'
  }) : null;

  function $canShare() {
    return $q(function(resolve, reject) {
      if (!chrExt) {
        return resolve({code: 'not_supported', message: 'Screensharing is not supported on this device'});
      }

      chrExt.available(function(err) {
        if(!err) {
          return resolve();
        }

        if(chrExt.type === 'google/chrome') {
          return resolve({code: 'chrome_ext', message: 'You need the chrome extension to share your screen'});
        }

        reject(err);
      });
    });
  }

  function handleShareRequest(err) {
    if (!err) {
      return;
    }

    if (err.code === 'chrome_ext') {
      return $q(function(resolve) {
        var extModal = modals.ssChromeExt();
        extModal.modal('show');
        chrExt.on('activate', function() {
          extModal.modal('hide');
          resolve();
        });
      });
    }

    if (err.code === 'not_supported') {
      modals.ssNotSupported().modal('show');
      return $q.reject(err.message);
    }
  }

  function requestScreen() {
    return $q(function(resolve, reject) {
      chrExt.request(function(err, constraints) {
        if(err) {
          console.error('ScreenShare: request error', err);
          reject(err);
        }

        resolve(constraints);
      });
    });
  }

  function getUserMedia(constraints) {
    return navigator.mediaDevices.getUserMedia({
      video: constraints.video,
    });
  }

  var getUserMediaScreen = function(room, user) {
    return $canShare()

      .then(handleShareRequest)
      .then(requestScreen)
      .then(getUserMedia)

      .then(function(stream){
        var conn = connect(room, user);
        conn.addStream(stream);
        setTimeout(conn.bind(conn, 'localstream:added', stream));

        var onremove = function() {
          conn.removeStream.call(conn, stream);
          setTimeout(conn.bind(conn, 'localstream:removed'));
        };

        // remove stream when becomes innactive
        stream.addEventListener('inactive', onremove);
        stream.addEventListener('removetrack', onremove);

        return conn;
      })
      .catch(function(e) {
        console.error(e);
        return $q.reject(e);
      });
  };

  var stopSharing = function(room, user, _conn) {
    var conn = _conn || connect(room ,user);

    conn.getLocalStreams().forEach(function(stream) {
      stream.getTracks().forEach(function(track){ track.stop(); });
    });
  };

  return {
    share: getUserMediaScreen,
    stopSharing: stopSharing,
    canShare: $canShare,
  };
}])

.filter('simpleViewStreams', ['connect', function(connect) {
  return function(user, bridge) {
    var conn = connect(bridge, user);
    if(conn.calls.values().length) {
      return conn.calls.values()[0].streams;
    }
  };
}]);

require('./peer-data-channel');
require('./directives/share-btn');
require('./directives/video-stream');
require('./auth.guard');
require('./chat.service');
require('./slideshare.service');
require('./directives/slideshare-btn');



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/index.js
 ** module id = 195
 ** module chunks = 0
 **/